<template>
  <v-container class="fill-height bg" fluid :style="{ backgroundImage: `url('${backgroundURL}')` }">
    <div class="logo">
      <img :src="welcomeLogoURL" alt="">
    </div>
    <v-row class="fade-in text-center" no-gutters align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-carousel class="carousel" hide-delimiter-background :show-arrows="false" cycle height="200">
          <v-carousel-item v-for="message in messages" :key="message.title">
            <v-sheet
              color="transparent"
              height="100%"
              tile
            >
            <v-row no-gutters :style="`color: ${textColour};`">
              <v-col cols="12">
                <div class="headline">{{message.title}}<br>
                <span class="body-1">{{message.text}}</span>
                </div>
              </v-col>
            </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
    <v-row no-gutters align="center" justify="center" class="text-center fade-in">
      <v-col cols="5" sm="3">
        <v-btn color="primary" rounded block to="/login">Login</v-btn><br>
        <v-btn rounded outlined block dark to="/register">Register</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

const env = window.localStorage.getItem('env')

export default {
  computed: {
    appConfig () {
      return this.$store.getters['app/config']
    },
    welcomeLogoURL () {
      return this.appConfig ? `${this.appConfig.assetServerURL}/${env}${this.appConfig.welcomeLogoURL}` : ''
    },
    backgroundURL () {
      return this.appConfig ? `${this.appConfig.assetServerURL}/${env}${this.appConfig.welcomeBackgroundURL}` : ''
    },
    messages () {
      return this.appConfig ? this.appConfig.welcomeMessages : []
    },
    textColour () {
      return this.appConfig ? this.appConfig.welcomeTextColour : '#FFFFFF'
    }
  },
  data: () => ({
  }),
  created () {
    console.log('WelcomeCustom.vue')
    console.log(this.$route.params.id)
  },
  methods: {
  }
}
</script>

<style scoped>
.bg {
  /* background: url("/img/welcome-screen.png"); */
  height: 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.logo {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 165px;
  height: 180px;
  margin-top: -90px; /* Half the height */
  margin-left: -82px; /* Half the width */
  -webkit-animation: slide-bck-top 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) 2s both;
  animation: slide-bck-top 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) 2s both;
}

@-webkit-keyframes slide-bck-top {
  0% {
    -webkit-transform: translateY(0) scale(1);
            transform: translateY(0) scale(1);
  }
  100% {
    -webkit-transform: translateY(-300px) scale(0.5);
            transform: translateY(-300px) scale(0.5);
  }
}
@keyframes slide-bck-top {
  0% {
    -webkit-transform: translateY(0) scale(1);
            transform: translateY(0) scale(1);
  }
  100% {
    -webkit-transform: translateY(-300px) scale(0.5);
            transform: translateY(-300px) scale(0.5);
  }
}

.fade-in{
  -webkit-animation: 5s ease 0s normal forwards 1 fadein;
  animation: 5s ease 0s normal forwards 1 fadein;
}

@keyframes fadein{
  0% { opacity:0; }
  66% { opacity:0; }
  100% { opacity:1; }
}

@-webkit-keyframes fadein{
  0% { opacity:0; }
  66% { opacity:0; }
  100% { opacity:1; }
}

.carousel {
  position: relative;
  top: 50%;
  -webkit-transform: translateY(50%);
  -ms-transform: translateY(50%);
  transform: translateY(50%);
}
</style>
